<div *ngIf="debugEnabled">
  <a (click)="openCloseClicked()">+ {{opened ? 'Close' : 'Open'}} Debug JSON: {{description}}</a>
  <div *ngIf="opened" class="debug-json-container">
    <pre>{{ data | json}}</pre>
  </div>
</div>
